<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     :selected-data="selectedUsuario"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent v-if="collectionData.length" :entity="entity" :selected-data="selectedUsuario"
                    :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :subTableColumn="'permisosUsuariosEntities'"
                    @updateValues="setupUpdateValues" :custom-action-buttons="' <br> Se ha envíado un correo electrónico al usuario para actualización de contraseña.'"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else-if="view === 'actualizar' || view === 'crear'">
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedUsuario"
                           :load-data="view === 'crear' ? loadDataUsuario : {nombre_completo: loadDataUsuario.nombre_completo, usuario: loadDataUsuario.usuario, email: loadDataUsuario.email, rol_id: loadDataUsuario.rol_id}"
                           :customSaveData="customSaveData" :skipDefaultSave="true" :entity="entity"
                           :auth-token="authToken" :list-api="listApi" :queries="queries"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :parentView="view" :load-data="loadDataUsuario"
                 :loadDataPermisosAdicionales="loadDataPermisosAdicionales" :auth-token="authToken"
                 @updateValues="setupUpdateValues"
                 @updateLoadDataPermisosAdicionales="(index)=>loadDataPermisosAdicionales[index].checked = !loadDataPermisosAdicionales[index].checked"></component>
    </CreateUpdateComponent>
  </template>
  <template v-else>
    <component :is="subtableComponent" :selectedUsuario="selectedUsuario" @updateValues="setupUpdateValues"></component>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import UsuariosCrearActualizarComponent from "@/components/auth/components/UsuariosCrearActualizarComponent";
import PermisosAdicionalesSubtableComponent from "./components/PermisosAdicionalesSubtableComponent.vue";
import {listCollectionData, updateValues, useLayoutMain} from "@/layouts/main";
import {generateTextError, swal, useAPIRest, verifyHttpCode,} from "@/common/constants";

/**
 * Componente para realizar CRUD a usuarios.
 * @vue
 * @vue-show-source
 * @vue-data {Array} customSaveData - Una lista de funciones personalizadas que serán ejecutadas cuando se cree o actualice un usuario.
 * @vue-data {function} setupLoadDataPermisosAdicionales - Una función que carga todos los permisos adicionales disponibles con su respectivo estado en checkboxes.
 */
export default {
  name: 'UsuariosCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    UsuariosCrearActualizarComponent,
    PermisosAdicionalesSubtableComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Usuarios',
      entity: {gender: 'm', value: 'usuario'},
      childFormComponent: 'usuariosCrearActualizarComponent',
      subtableComponent: 'permisosAdicionalesSubtableComponent',
      tableColumns: {
        "id": {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: "ID",
        },
        "nombre_completo": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre completo",
        },
        "usuario": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Usuario",
        },
        "email": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Correo",
        },
        "rol.nombre": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Rol",
        },
        "permisosUsuariosEntities": {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: "permisos adicionales",
        },
        "created_at": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: "Fecha de creación",
        },
      },
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedUsuario = ref({
      id: '',
      nombre_completo: '',
      usuario: '',
      email: '',
      rol_id: '',
      estado: ''
    });
    const loadDataUsuario = ref({
      nombre_completo: '',
      usuario: '',
      email: '',
      rol_id: '',
      password: '',
    });
    const loadDataPermisosAdicionales = ref([]);
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_AUTH_CREATE,
      list: process.env.VUE_APP_NEST_AUTH_FINDALL,
      update: process.env.VUE_APP_NEST_AUTH_UPDATE,
      updateState: process.env.VUE_APP_NEST_AUTH_UPDATESTATE
    });
    const customSaveData = ref([
      async () => {
        let textoExitoso;
        textoExitoso = 'El usuario fue ' + (view.value === 'crear' ? 'creado' : 'actualizado') + ' exitosamente!';
        const callbackCreateUpdate = async (resJSON) => {
          const {statusCode} = resJSON;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            if (view.value === "crear")
              for (const checkbox of loadDataPermisosAdicionales.value) {
                await useAPIRest(process.env.VUE_APP_NEST_PERMISOUSER_CREATE + "?estado=" + +checkbox.checked, 'POST', authToken.value, {
                  permiso_id: checkbox.permiso.id,
                  usuario_id: resJSON.id
                })
              }
            else if (view.value === "actualizar")
              for (const checkbox of loadDataPermisosAdicionales.value) {
                await useAPIRest(process.env.VUE_APP_NEST_PERMISOUSER_UPDATESTATE + "?estado=" + +checkbox.checked, 'PATCH', authToken.value, {
                  permiso_id: checkbox.permiso.id,
                  usuario_id: resJSON.id
                })
              }
            await swal.fire(textoExitoso, '', 'success');
            await listCollectionData(listApi['list'], setupUpdateValues, authToken.value, paginate.value.page, queries.value.orderBy, queries.value.order, queries.value.criterion, queries.value.search).then((resJSON) => {
              const {statusCode} = resJSON;
              if (verifyHttpCode(statusCode, 'success')) view.value = 'listar';
            });
          } else await swal.fire(textoError, '', 'error');
          return resJSON;
        };
        if (view.value === 'crear') await useAPIRest(listApi['create'], 'POST', authToken.value, loadDataUsuario.value).then(async resJSON => await callbackCreateUpdate(resJSON));
        else await useAPIRest(listApi['update'].replace(':id', selectedUsuario.value.id), 'PATCH', authToken.value, {
          nombre_completo: loadDataUsuario.value.nombre_completo,
          usuario: loadDataUsuario.value.usuario,
          email: loadDataUsuario.value.email,
          rol_id: loadDataUsuario.value.rol_id
        }).then(async resJSON => await callbackCreateUpdate(resJSON));
      }
    ]);
    const setupLoadDataPermisosAdicionales = async (rol_id) => {
      const permisos = await useAPIRest(process.env.VUE_APP_NEST_PERMISO_FINDALL, 'GET', authToken.value, undefined, {
        page: 1,
        orderBy: 'created_at',
        order: 'ASC',
        criterion: '',
        search: '',
        where: '',
        isPaginate: false
      });
      const permisosRol = await useAPIRest(process.env.VUE_APP_NEST_PERMISOROL_FINDALL, 'GET', authToken.value, undefined, {
        page: 1,
        orderBy: 'created_at',
        order: 'ASC',
        criterion: '',
        search: '',
        where: 'rol_id = "' + rol_id + '" AND table.estado = 1',
        isPaginate: false
      });
      let permisosSobrantes = []
      if (rol_id)
        permisosSobrantes = permisos.filter(function (permiso) {
          for (const permisoRol of permisosRol) {
            if (permiso.id === permisoRol.permiso_id)
              return false
          }
          return true
        });
      const permisosUsuario = await useAPIRest(process.env.VUE_APP_NEST_PERMISOUSER_FINDALL, 'GET', authToken.value, undefined, {
        page: 1,
        orderBy: 'created_at',
        order: 'ASC',
        criterion: '',
        search: '',
        where: 'usuario_id = "' + selectedUsuario.value.id + '" AND table.estado = 1',
        isPaginate: false
      });
      const checkboxes = [];
      for (const permiso of permisosSobrantes) {
        let usuarioHasPermiso = false;
        for (const permisoUsuario of permisosUsuario) {
          if (permiso.id === permisoUsuario.permiso_id)
            usuarioHasPermiso = true;
        }
        if (usuarioHasPermiso)
          checkboxes.push({permiso: permiso, checked: true})
        else
          checkboxes.push({permiso: permiso, checked: false})
      }
      updateValues({["loadDataPermisosAdicionales"]: checkboxes}, {"loadDataPermisosAdicionales": loadDataPermisosAdicionales})
    }
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedUsuario, loadDataUsuario, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedUsuario,
      loadDataUsuario,
      customSaveData,
      loadDataPermisosAdicionales,
      listApi,
      paginate,
      queries,
      setupLoadDataPermisosAdicionales,
      setupUpdateValues,
      cleanLoadSelectedData,
    };
  },
  watch: {
    loadDataUsuario: {
      handler(newValue) {
        this.setupLoadDataPermisosAdicionales(newValue.rol_id)
      },
      deep: true
    }
  }
}
</script>